export const enum IconSlugMobile {
  MAESTRO = 'delivery_payment_card_maestro',
  MASTERCARD = 'delivery_payment_card_mastercard',
  MIR = 'delivery_payment_card_mir',
  UNKNOWN = 'delivery_payment_card_placeholder',
  VISA = 'delivery_payment_card_visa',
}
